module.exports = __webpack_public_path__ + "app/invited-entity/modals/modal-resend-invitation-3o6vjMjx.html";